import { render, staticRenderFns } from "./StepSign.vue?vue&type=template&id=2b7f9ef7&scoped=true&"
import script from "./StepSign.vue?vue&type=script&lang=js&"
export * from "./StepSign.vue?vue&type=script&lang=js&"
import style0 from "./StepSign.vue?vue&type=style&index=0&id=2b7f9ef7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7f9ef7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
